module.exports = __webpack_public_path__ + "static/media/sg14cr93.4e9808bc.png";